import { translations } from "../../i18n";
import { trackInitiateCheckout } from "../../lib/pixel";
import { buildRegisterUrl } from "../../lib/tracking-url";

type Translation = (typeof translations)["de"];

function CTA({
  isVisible,
  t,
}: {
  isVisible: (id: string) => boolean;
  t: Translation["cta"];
}) {
  return (
    <section
      id="cta"
      data-animate
      className={`py-16 sm:py-24 md:py-32 transition-all duration-1000 relative overflow-hidden ${
        isVisible("cta")
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-10"
      }`}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 md:mb-8 leading-tight">
          {t.heading} <span className="text-orange-500">{t.highlight}</span>
        </h2>
        <p className="text-base sm:text-lg md:text-2xl text-slate-400 mb-8 sm:mb-10 md:mb-12">{t.description}</p>
        <a
          href={buildRegisterUrl("https://app.neosearch.neobim.ai/start")}
          onClick={() => trackInitiateCheckout({ source: "cta_section" })}
        >
          <button className="px-8 sm:px-10 md:px-12 py-4 sm:py-5 bg-orange-500 hover:bg-orange-600 text-white text-base sm:text-lg md:text-xl font-semibold rounded-lg transition-all hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/50 active:scale-95 group animate-pulse-subtle">
            {t.cta}
            <span className="inline-block ml-2 group-hover:translate-x-2 transition-transform">
              →
            </span>
          </button>
        </a>
      </div>
    </section>
  );
}

export default CTA;